import React from "react";
import { Link } from "react-router-dom";
import { Trash2, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";

const CartPage = () => {
  const { items, removeItem, clear, total } = useCart();

  return (
    <main className="bg-white">
      <div className="bg-gradient-to-r from-zinc-50 to-rose-50/30 border-b border-zinc-100">
        <div className="max-w-7xl mx-auto px-4 py-10">
          <h1 className="text-4xl font-bold text-zinc-900">Your Cart</h1>
          <p className="text-zinc-600 mt-1">{items.length} item{items.length === 1 ? "" : "s"} · free local pickup in Fort Lauderdale</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          {items.length === 0 ? (
            <div className="text-center py-20 border border-dashed border-zinc-200 rounded-xl">
              <ShoppingBag className="w-12 h-12 text-zinc-300 mx-auto mb-4" />
              <div className="text-lg font-semibold text-zinc-900">Your cart is empty</div>
              <p className="text-sm text-zinc-500 mt-1">Add a product to get started.</p>
              <Link to="/shop" className="inline-flex items-center gap-2 mt-6 bg-zinc-900 text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-rose-500 transition-colors">
                Shop products <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ) : (
            <ul className="space-y-4">
              {items.map((it) => (
                <li key={it.lineId} className="flex gap-5 items-start border border-zinc-200 rounded-lg p-4">
                  <img src={it.image} alt={it.name} className="w-24 h-24 rounded-md object-cover bg-zinc-50" />
                  <div className="flex-1">
                    <Link to={`/product/${it.slug}`} className="font-bold text-zinc-900 hover:text-rose-500 transition-colors">{it.name}</Link>
                    <div className="text-xs text-zinc-600 mt-1 space-x-3">
                      {it.size && <span>Size: <strong>{it.size}</strong></span>}
                      {it.finish && <span>· Option: <strong>{it.finish}</strong></span>}
                      {it.stand && <span>· Stand: <strong>{it.stand}</strong></span>}
                    </div>
                    <div className="text-xs text-zinc-600 mt-1">Qty: <strong>{it.qty}</strong> · {it.production === "express" ? "Express" : "Regular"} · {it.design === "designed" ? "Designed by Design Plus" : "Upload my design"}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-bold text-zinc-900">${Number(it.price).toFixed(2)}</div>
                    <button onClick={() => removeItem(it.lineId)} className="text-xs text-rose-500 hover:underline mt-2 inline-flex items-center gap-1"><Trash2 className="w-3 h-3" /> Remove</button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <aside className="lg:col-span-1">
          <div className="bg-zinc-50 rounded-xl p-6 sticky top-32">
            <h3 className="font-bold text-zinc-900 text-lg mb-4">Order summary</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between text-zinc-600"><span>Subtotal</span><span>${total.toFixed(2)}</span></div>
              <div className="flex justify-between text-zinc-600"><span>Shipping</span><span>{total >= 65 ? "Free" : "$8.99"}</span></div>
              <div className="flex justify-between text-zinc-600"><span>Tax (est.)</span><span>${(total * 0.07).toFixed(2)}</span></div>
            </div>
            <div className="border-t border-zinc-200 mt-4 pt-4 flex justify-between text-lg font-bold text-zinc-900">
              <span>Total</span>
              <span>${(total + (total >= 65 ? 0 : 8.99) + total * 0.07).toFixed(2)}</span>
            </div>
            <button onClick={() => alert("Checkout is mocked in this demo build.")} disabled={items.length === 0} className="w-full mt-5 bg-zinc-900 text-white py-3.5 rounded-md text-sm font-bold hover:bg-rose-500 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">Proceed to Checkout</button>
            {items.length > 0 && (
              <button onClick={clear} className="w-full mt-2 text-xs text-zinc-500 hover:text-rose-500">Clear cart</button>
            )}
            <p className="text-[11px] text-zinc-500 mt-4 leading-relaxed">Free local pickup at our Fort Lauderdale studio. Free shipping over $65.</p>
          </div>
        </aside>
      </div>
    </main>
  );
};

export default CartPage;
